module.exports = __webpack_public_path__ + "static/frost_giant_parlament-4b27b74bce26cdbbcbac0977ea560d07.jpg";